import React, { useState, useMemo, useEffect } from 'react';
import classes from './styles.module.scss';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  ButtonGroup,
  Button,
  Flex,
  Box
} from '@chakra-ui/react';
import clsx from 'clsx';
import { SECTION_NAMES } from 'data/faq';

const FAQ = ({ list, showLength = Infinity, isNotBlog, initialLang = 'en', onLangChange }) => {
  const [lang, setLang] = useState(initialLang);

  // Update lang when initialLang prop changes
  useEffect(() => {
    setLang(initialLang);
  }, [initialLang]);

  // Notify parent component of language changes
  useEffect(() => {
    if (onLangChange) {
      onLangChange(lang);
    }
  }, [lang, onLangChange]);

  // Group FAQs by section
  const groupedFaqs = useMemo(() => {
    const groups = {};
    list.forEach((faq) => {
      if (faq[lang]) {
        const sectionKey = faq.sectionKey || 'general';
        if (!groups[sectionKey]) {
          groups[sectionKey] = [];
        }
        groups[sectionKey].push(faq);
      }
    });
    return groups;
  }, [list, lang]);

  const sectionKeys = Object.keys(groupedFaqs);

  return (
    <Flex
      direction="column"
      gap={6}
      alignItems={['flex-start', null, 'center']}
    >
      {/* Language Tabs */}
      <Box>
        <ButtonGroup variant="solid" spacing="0" size="xs" isAttached>
          <Button
            colorScheme={lang === 'en' ? 'brand' : 'gray'}
            onClick={() => setLang('en')}
          >
            English
          </Button>
          <Button
            colorScheme={lang === 'hi' ? 'brand' : 'gray'}
            onClick={() => setLang('hi')}
          >
            हिंदी
          </Button>
          <Button
            colorScheme={lang === 'mr' ? 'brand' : 'gray'}
            onClick={() => setLang('mr')}
          >
            मराठी
          </Button>
          <Button
            colorScheme={lang === 'gu' ? 'brand' : 'gray'}
            onClick={() => setLang('gu')}
          >
            ગુજરાતી
          </Button>
          <Button
            colorScheme={lang === 'id' ? 'brand' : 'gray'}
            onClick={() => setLang('id')}
          >
            Indonesian
          </Button>
        </ButtonGroup>
      </Box>

      {/* FAQ Sections */}
      <Box width="100%">
        {sectionKeys.map((sectionKey) => (
          <Box key={sectionKey} mb={8}>
            <h3 className={classes.sectionTitle}>
              {SECTION_NAMES[sectionKey]?.[lang] || sectionKey}
            </h3>
            <Accordion
              allowMultiple
              className={clsx(
                classes.blogContainer,
                isNotBlog && classes.container
              )}
            >
              {groupedFaqs[sectionKey]
                .filter(
                  (item, index) =>
                    index < showLength || showLength === Infinity
                )
                .map((val) => (
                  <AccordionItem className={classes.item} key={val.key}>
                    <AccordionButton>
                      <h2 className={classes.question}>
                        {val[lang]?.title}
                      </h2>
                      <AccordionIcon fontSize={'35px'} color="#FFC165" />
                    </AccordionButton>
                    <AccordionPanel pb={4} className={classes.answer}>
                      <p className={classes.normalAnswer}>
                        {val[lang]?.desc}
                      </p>
                    </AccordionPanel>
                  </AccordionItem>
                ))}
            </Accordion>
          </Box>
        ))}
      </Box>
    </Flex>
  );
};

export default FAQ;
